import { Link } from "gatsby"
// import PropTypes from "prop-types"
import React from "react"
// import React, {useEffect, useState} from "react"

// React.useEffect(() => {
//   window.addEventListener("load", onHeaderLoad);
//   onHeaderLoad();
// });

const onHeaderLoad = () => {
  document.querySelector('.hamburger')?.classList.remove('hamburger-invert');
}

const handleHamburgerClick = (e) => {
  // toggle page scroll menu
  var body = document.body;
  body.classList.toggle("overlay-visible");

  // toggle the menu
  var menu = document.getElementById("menu");
  menu.classList.toggle("overlay-visible");

  // move the hamburger to cater for missing scrollbars
  var hamburger = document.getElementById("hamburger");
  hamburger.classList.toggle("overlay-visible");

  // overlay close button
  var overlayClose = document.getElementById("overlay-close");
  overlayClose.classList.toggle("overlay-visible");

  // let scrollbarWidth = (window.innerWidth - document.body.clientWidth) + 'px';
  // console.log(scrollbarWidth);

  // animate the burger icon
  if (menu.classList.contains("overlay-visible")) {
    // burger -> x
  }
  else {
    // x -> burger
  }

  // position menus at top
  document.querySelector('.scrolly-menu').scrollTo({top: 0, behavior: 'instant'});
  
};

const handleOverlayCloseClick = (e) => {
  // toggle page scroll menu
  var body = document.body;
  body.classList.toggle("overlay-visible");

  // toggle the menu
  var menu = document.getElementById("menu");
  menu.classList.toggle("overlay-visible");

  // move the hamburger to cater for missing scrollbars
  var hamburger = document.getElementById("hamburger");
  hamburger.classList.toggle("overlay-visible");

  // overlay close button
  var overlayClose = document.getElementById("overlay-close");
  overlayClose.classList.toggle("overlay-visible");

  // let scrollbarWidth = (window.innerWidth - document.body.clientWidth) + 'px';
  // console.log(scrollbarWidth);

  // animate the burger icon
  if (menu.classList.contains("overlay-visible")) {
    // burger -> x
  }
  else {
    // x -> burger
  }
  
  // close the menus
  // document.getElementById("sub-menu-service").style.display = 'none';
  // document.getElementById("sub-menu-casestudy").style.display = 'none';
  // document.querySelector(".menu-item-service").classList.remove('selected');
  // document.querySelector(".menu-item-casestudy").classList.remove('selected');
  // document.querySelector('.scrolly-menu').scrollTo({top: 0, behavior: 'instant'});

};

// const handleLinkClick = (e) => {
//   // trigger handleHamburgerClick
//   var hamburger = document.getElementById("hamburger");
//   // hamburger.classList.toggle("overlay-visible");
//   hamburger.click();
// };

const Header = () => (
  <>
    <header class="site-header" onLoad={onHeaderLoad}>
      <div class="grid-header">
        <div></div>
        <div class="site-logo">
          {/* <Link to="/"><img src="/images/shift-logo.svg" alt="SHIFT Active Media" /></Link> */}
          <Link to="/"><img src="/images/shift-logo.png" x-srcset="/images/shift-logo.png 1x, /images/shift-logo.svg 2x, /images/shift-logo.svg 3x" alt="SHIFT Active Media" /></Link>
        </div>
        <div class="hamburger" id="hamburger" onClick={handleHamburgerClick}>
          {/* <img src="/images/hamburger-black.svg" alt="Menu" /> */}
          <img src="/images/hamburger-3-lines.svg" alt="Menu" />
        </div>
        <div class="overlay-close" id="overlay-close" onClick={handleOverlayCloseClick}>
          <img src="/images/overlay-close.svg" alt="Close menu" />
        </div>
      </div>
    </header>    
  </>
)

// Header.propTypes = {
//   siteTitle: PropTypes.string,
// }

// Header.defaultProps = {
//   siteTitle: ``,
// }

export default Header
